<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> app_registration </span>Gestion
          des clients
        </div>
      </div>
</div>
      <div id="contratTab" class="tabElementContent active">
        <div @click="addNewCustomer" class="buttonAdd">
          <span> Ajouter un nouveau client </span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
              @click="editeCustomerRow(item)"
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in customerListData"
                :key="item._id"
              >
                <td>
                  {{ item.company  }}
                </td>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ item.phones.join("/") }}
                </td>
                <td>
                  {{ item.email }}
                </td>
                <td>
                  {{ item.address }}
                </td>
                <!-- <td>
                  {{ item.role }}
                </td> -->
                <td>
                  {{ item.wallet.balance }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "customerManage",
  components: {},
  data: () => ({
    tableHeader: [
      "Raison sociale",
      "Nom complet",
      "Contact",
      "Email",
      "Adresse",
      // "Type de client",
      "Portefeuille",
    ],
    isSelecteds: [],
    isSelectedAll: false,
  }),
  computed: {
    ...mapGetters([
      //   "contratData",
      //   "blData",
      //   "conteneurData",
      //   "contenuerAllData",
      //   "storeData",
      "customerListData",
    ]),
  },
  async mounted() {
    await this.getCustomerList({});
  },
  methods: {
    ...mapActions([
      //   "getContrat",
      //   "getSupplier",
      //   "getContratDetails",
      //   "getBl",
      //   "getConteneur",
      //   "getConteneurAll",
      //   "getTransitaire",
      //   "getStore",
      "getCustomerList",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async addNewCustomer() {
      this.$emit("show",true)
      const value = {
        modalType: "customer",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "customer",
        size: 300,
        value: value,
      });
      this.$emit("show",false)
    },
    editeCustomerRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.customerListData.length; i++) {
          this.customerListData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.customerListData);
        const value = {
          _id: item._id,
          modalType: "customer",
          role: item.role,
          email: item.email,
          name: item.name,
          company: item.company,
          address: item.address,
          phones: item.phones.join("/"),
        };
        this.$emit("editeRowForDash", {
          name: "customer",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("show",true)
      this.$emit("closeAllModal");
      if (tabName === "contrat") {
        await this.getContrat({});
      } else if (tabName === "bl") {
        await this.getBl({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show",false)
    },
  },
};
</script>
    